/* Gwennie quiz: questions, result, share card, waitlist tags */
(function () {
  var root = document.querySelector('[data-gw-quiz]');
  if (!root || root.__gwq) return;
  root.__gwq = true;

  var cfgEl = root.querySelector('[data-gw-quiz-config]');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
  cfg.results = cfg.results || {};
  cfg.colors = cfg.colors || {};
  cfg.colorLines = cfg.colorLines || {};

  var MOODS = ['Original', 'Sweetie', 'Daydream', 'Starstruck', 'Cool Girl', 'Sleepy'];
  var COLORS = ['Blush', 'Cream', 'Lilac', 'Sage'];
  var MOOD_LINES = {
    'Original': 'Classic, funny, always down.',
    'Sweetie': 'Soft heart. Strawberry everything.',
    'Daydream': 'Head in the clouds, glitter in the pockets.',
    'Starstruck': 'Main character energy, every day.',
    'Cool Girl': 'Calm, clean, quietly iconic.',
    'Sleepy': 'Blanket pile. Late brunch. No rush.'
  };
  var MOOD_BUBBLES = {
    'Original': 'Knew it. Hi, twin.',
    'Sweetie': 'Aww. I like you already.',
    'Daydream': 'You were somewhere else just now, huh.',
    'Starstruck': 'Okay, star. Everyone look.',
    'Cool Girl': 'Say less. I get it.',
    'Sleepy': 'Same. Five more minutes.'
  };

  var screens = Array.prototype.slice.call(root.querySelectorAll('[data-gw-screen]'));
  var questions = screens.filter(function (s) { return s.hasAttribute('data-gw-question'); });
  var total = questions.length;
  var moodVotes = {}, colorVotes = {}, answered = 0, current = 'intro', result = null;
  var track = window.gwTrack || function () {};

  function show(name) {
    var from = root.querySelector('[data-gw-screen].is-active');
    var to = root.querySelector('[data-gw-screen="' + name + '"]');
    if (!to) return;
    current = name;
    if (from && from !== to) {
      from.classList.add('is-leaving');
      setTimeout(function () {
        from.classList.remove('is-active', 'is-leaving');
        to.classList.add('is-active');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 200);
    } else {
      to.classList.add('is-active');
    }
  }

  function setProgress(n) {
    root.querySelectorAll('[data-gw-progress]').forEach(function (el) {
      el.style.width = Math.round((n / total) * 100) + '%';
    });
  }

  function tally(votes, order) {
    var best = order[0], bestN = -1;
    order.forEach(function (k) {
      var n = votes[k] || 0;
      if (n > bestN) { best = k; bestN = n; }
    });
    return best;
  }

  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }

  function saveGlobalPick(mood, color) {
    try { localStorage.setItem('gw_pick', JSON.stringify({ mood: mood, color: color })); } catch (e) {}
    try { localStorage.setItem('gw_quiz_result', JSON.stringify({ mood: mood, color: color, ts: Date.now() })); } catch (e) {}
  }

  function finish(restoring) {
    var mood = tally(moodVotes, MOODS);
    var color = tally(colorVotes, COLORS);
    result = { mood: mood, color: color };
    saveGlobalPick(mood, color);
    var r = cfg.results[mood] || {};
    var bubble = r.bubble || MOOD_BUBBLES[mood];
    var line = r.line || MOOD_LINES[mood];
    var colorLine = cfg.colorLines[color] || color;

    root.querySelectorAll('[data-gw-result-img]').forEach(function (el) {
      el.hidden = el.getAttribute('data-gw-result-img') !== mood;
    });
    var sw = root.querySelector('[data-gw-result-swatch]');
    if (sw) sw.style.background = cfg.colors[color] || '#f7cbd6';
    var bub = root.querySelector('[data-gw-result-bubble]');
    if (bub) bub.textContent = bubble;
    var title = root.querySelector('[data-gw-result-title]');
    if (title) title.textContent = "You're " + article(mood) + ' ' + mood + ' in ' + color + '.';
    var ln = root.querySelector('[data-gw-result-line]');
    if (ln) ln.textContent = line + ' ' + colorLine;
    var sup = root.querySelector('[data-gw-quiz-list-support]');
    if (sup) sup.textContent = 'Leave your email and ' + mood + ' in ' + color + ' is saved with it.';
    root.querySelectorAll('[data-gw-quiz-tags]').forEach(function (el) {
      el.value = ['gwennie-list', 'quiz:yes', 'mood:' + mood, 'color:' + color, 'quiz-result:' + slug(mood) + '-' + slug(color)].join(', ');
    });
    show('result');
    if (!restoring) track('quiz_result', { mood: mood, color: color });
    setTimeout(burst, 500);
  }

  function article(word) { return /^[aeiou]/i.test(word) ? 'an' : 'a'; }

  /* tap sparkles */
  function spark(x, y, n) {
    for (var i = 0; i < (n || 6); i++) {
      var s = document.createElement('span');
      s.className = 'gwq-spark';
      var a = Math.random() * Math.PI * 2, d = 30 + Math.random() * 50;
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--dx', Math.cos(a) * d + 'px');
      s.style.setProperty('--dy', Math.sin(a) * d + 'px');
      s.style.color = ['#d9366e', '#f7cbd6', '#dccbf0', '#ffd678'][i % 4];
      document.body.appendChild(s);
      setTimeout(function (el) { el.remove(); }, 800, s);
    }
  }
  function burst() {
    var hero = root.querySelector('[data-gw-screen="result"] .gw-quiz__hero');
    if (!hero) return;
    var r = hero.getBoundingClientRect();
    for (var i = 0; i < 4; i++) {
      setTimeout(function () { spark(r.left + Math.random() * r.width, r.top + Math.random() * r.height, 8); }, i * 120);
    }
  }

  /* answers */
  root.addEventListener('click', function (e) {
    var start = e.target.closest('[data-gw-quiz-start]');
    if (start) {
      moodVotes = {}; colorVotes = {}; answered = 0;
      setProgress(0);
      track('quiz_started', {});
      show('q1');
      spark(e.clientX, e.clientY, 8);
      return;
    }
    var ans = e.target.closest('[data-gw-answer]');
    if (ans && ans.closest('[data-gw-screen].is-active')) {
      var screen = ans.closest('[data-gw-screen]');
      if (screen.__done) return;
      screen.__done = true;
      ans.classList.add('is-picked');
      var m = ans.getAttribute('data-gw-mood-vote'), c = ans.getAttribute('data-gw-color-vote');
      if (m) moodVotes[m] = (moodVotes[m] || 0) + 1;
      if (c) colorVotes[c] = (colorVotes[c] || 0) + 1;
      answered += 1;
      setProgress(answered);
      spark(e.clientX, e.clientY, 7);
      var idx = parseInt(screen.getAttribute('data-gw-question'), 10);
      track('quiz_answered', { question: idx, mood_vote: m, color_vote: c });
      setTimeout(function () {
        ans.classList.remove('is-picked');
        screen.__done = false;
        if (idx >= total) finish(); else show('q' + (idx + 1));
      }, 380);
      return;
    }
    var restart = e.target.closest('[data-gw-quiz-restart]');
    if (restart) {
      track('quiz_restarted', {});
      show('intro');
      return;
    }
    var save = e.target.closest('[data-gw-card-save]');
    if (save) { makeCard(function (blob) { download(blob); }); track('card_saved', result || {}); return; }
    var share = e.target.closest('[data-gw-card-share]');
    if (share) { shareCard(); return; }
  });

  /* waitlist submit on this page */
  root.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('#gw-quiz-form');
    if (!form) return;
    track('waitlist_submitted', Object.assign({ source: 'quiz' }, result || {}));
  });

  /* card */
  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }
  function star(ctx, cx, cy, r, col) {
    ctx.save(); ctx.fillStyle = col; ctx.beginPath();
    for (var i = 0; i < 8; i++) {
      var a = i * Math.PI / 4 - Math.PI / 2, rr = i % 2 ? r * 0.3 : r;
      ctx[i ? 'lineTo' : 'moveTo'](cx + rr * Math.cos(a), cy + rr * Math.sin(a));
    }
    ctx.closePath(); ctx.fill(); ctx.restore();
  }
  function makeCard(done) {
    if (!result) return;
    var canvas = root.querySelector('[data-gw-card-canvas]');
    var ctx = canvas.getContext('2d');
    var W = canvas.width, H = canvas.height;
    var colorHex = cfg.colors[result.color] || '#f7cbd6';
    ctx.fillStyle = '#fff6f2'; ctx.fillRect(0, 0, W, H);
    var g1 = ctx.createRadialGradient(200, 300, 10, 200, 300, 520); g1.addColorStop(0, colorHex); g1.addColorStop(1, 'rgba(255,246,242,0)');
    ctx.fillStyle = g1; ctx.fillRect(0, 0, W, H);
    var g2 = ctx.createRadialGradient(900, 1100, 10, 900, 1100, 520); g2.addColorStop(0, '#dccbf0'); g2.addColorStop(1, 'rgba(255,246,242,0)');
    ctx.fillStyle = g2; ctx.fillRect(0, 0, W, H);
    for (var i = 0; i < 26; i++) {
      star(ctx, Math.random() * W, Math.random() * H, 8 + Math.random() * 16, ['#d9366e', '#ffffff', '#ffd678', '#dccbf0'][i % 4]);
    }
    ctx.fillStyle = '#d9366e'; ctx.textAlign = 'center';
    ctx.font = '600 44px Fredoka, Poppins, Arial, sans-serif';
    ctx.fillText((cfg.cardTitle || "I'm a").replace(/\s+a$/, ' ' + article(result.mood)), W / 2, 150);
    ctx.font = '600 120px Fredoka, Poppins, Arial, sans-serif';
    ctx.fillText(result.mood, W / 2, 275);
    ctx.fillStyle = '#4a2a38'; ctx.font = '600 56px Fredoka, Poppins, Arial, sans-serif';
    ctx.fillText('in ' + result.color, W / 2, 350);

    var imgWrap = root.querySelector('[data-gw-result-img="' + result.mood + '"] img');
    var src = imgWrap ? (imgWrap.currentSrc || imgWrap.src) : '';
    var img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = function () { drawImg(img); };
    img.onerror = function () { drawImg(null); };
    if (src) img.src = src; else drawImg(null);

    function drawImg(im) {
      var size = 640, x = (W - size) / 2, y = 420;
      ctx.save(); roundRect(ctx, x, y, size, size, 60); ctx.clip();
      if (im) {
        var s = Math.max(size / im.width, size / im.height);
        ctx.drawImage(im, x + (size - im.width * s) / 2, y + (size - im.height * s) / 2, im.width * s, im.height * s);
      } else { ctx.fillStyle = colorHex; ctx.fillRect(x, y, size, size); }
      ctx.restore();
      ctx.beginPath(); ctx.arc(x + size - 30, y + size - 30, 44, 0, Math.PI * 2); ctx.fillStyle = colorHex; ctx.fill();
      ctx.lineWidth = 8; ctx.strokeStyle = '#fff'; ctx.stroke();
      ctx.fillStyle = '#4a2a38'; ctx.font = '500 40px Caveat, Nunito, Arial, sans-serif'; ctx.textAlign = 'center';
      var line = (cfg.results[result.mood] || {}).line || MOOD_LINES[result.mood];
      ctx.fillText(line, W / 2, 1130);
      ctx.fillStyle = '#d9366e'; ctx.font = '600 36px Fredoka, Poppins, Arial, sans-serif';
      ctx.fillText(cfg.cardFooter || 'Which Gwennie are you? gwennie.shop', W / 2, 1230);
      try { canvas.toBlob(function (b) { done(b); }, 'image/png'); }
      catch (e) { done(null); }
    }
  }
  function download(blob) {
    if (!blob) return;
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'my-gwennie-' + slug(result.mood) + '-' + slug(result.color) + '.png';
    document.body.appendChild(a); a.click(); a.remove();
  }
  function shareCard() {
    var url = (cfg.site || location.origin) + (cfg.handle || location.pathname);
    var text = "I'm " + article(result.mood) + ' ' + result.mood + ' in ' + result.color + '. Which Gwennie are you?';
    makeCard(function (blob) {
      var file = blob ? new File([blob], 'my-gwennie.png', { type: 'image/png' }) : null;
      if (navigator.share && file && navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({ files: [file], text: text, url: url }).then(function () { track('card_shared', Object.assign({ method: 'native' }, result)); }).catch(function () {});
      } else if (navigator.share) {
        navigator.share({ text: text, url: url }).then(function () { track('card_shared', Object.assign({ method: 'native-text' }, result)); }).catch(function () {});
      } else {
        download(blob);
        try { navigator.clipboard.writeText(text + ' ' + url); } catch (e) {}
        track('card_shared', Object.assign({ method: 'download' }, result));
      }
    });
  }

  /* returning visitor: after a successful signup, show the success state on the result screen */
  if (/customer_posted=true/.test(location.search)) {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('gw_quiz_result') || 'null'); } catch (e) {}
    if (saved && saved.mood) {
      moodVotes[saved.mood] = 1; colorVotes[saved.color] = 1;
      finish(true);
      setTimeout(function () {
        var list = root.querySelector('#gw-quiz-list');
        if (list) list.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 700);
    }
  }
})();
